import * as React from 'react';
import * as _ from 'lodash';
import { Card } from 'react-toolbox/lib/card';
import { CardActions } from 'react-toolbox/lib/card';
import { CardHeader } from 'react-toolbox/lib/card';
import { CardTitle } from 'react-toolbox/lib/card';
import { CardText } from 'react-toolbox/lib/card';
import { Field } from 'redux-form';
import Button from '../../../../utils/common_components/tooltipButton';
import IconButton from '../../../../utils/common_components/tooltipIconButton';
import RichTextEditor from '../../../../utils/common_components/rich_text_editor_form';
import TextInput from '../../../../utils/common_components/textInput_form';
import { Dialog } from 'react-toolbox/lib/dialog';
import { TetheredSelectWrap as Select } from '../../../../utils/common_components/tetheredSelect';
import { Table } from '../../../../vendor/reactable/reactable/table.jsx';
import { Thead } from '../../../../vendor/reactable/reactable/thead.jsx';
import { Th } from '../../../../vendor/reactable/reactable/th.jsx';
import { Tr } from '../../../../vendor/reactable/reactable/tr.jsx';
import { Td } from '../../../../vendor/reactable/reactable/td.jsx';
import FontIcon from 'react-toolbox/lib/font_icon';
import moment from 'moment';
export default function () {
    function repeatNotificationSchedule1(notificationSchedule, notificationScheduleIndex) {
        return React.createElement(Tr, { 'key': 'notificationSchedule' + notificationScheduleIndex }, React.createElement(Td, {
            'column': 'notification_text',
            'value': notificationSchedule.notification_template.notification_text
        }, React.createElement('div', {}, '\n                        ', notificationSchedule.notification_template.notification_text, '\n                    ')), React.createElement(Td, {
            'column': 'scheduled_date',
            'value': notificationSchedule.scheduled_date
        }, React.createElement('div', { 'className': 'text-center' }, '\n                        ', moment(notificationSchedule.scheduled_date).format('MMMM Do, YYYY'), '\n                    ')), React.createElement(Td, {
            'column': 'sent_status',
            'value': notificationSchedule.sent_status
        }, React.createElement('div', { 'className': 'text-center' }, notificationSchedule.sent_status ? React.createElement(FontIcon, {
            'className': 'c-success icon-scale',
            'value': 'check_circle',
            'key': '3647'
        }) : null, !notificationSchedule.sent_status ? React.createElement(FontIcon, {
            'className': 'c-danger icon-scale',
            'value': 'not_interested',
            'key': '3835'
        }) : null)), React.createElement(Td, {
            'column': 'action',
            'style': {
                width: '120px',
                textAlign: 'center'
            }
        }, React.createElement('div', {}, !notificationSchedule.sent_status ? React.createElement(Button, {
            'tooltip': 'Delete',
            'icon': 'delete',
            'className': 'micro bg-danger',
            'onClick': () => {
                this.deleteNotificationSchedule(notificationSchedule);
            },
            'floating': true,
            'mini': true,
            'key': '4258'
        }) : null)));
    }
    return React.createElement('div', { 'className': 'row w-100 m-20' }, React.createElement('div', { 'className': 'col-xs-12 m-t-30 p-r-30' }, React.createElement.apply(this, [
        Table,
        {
            'className': 'table reactable',
            'id': 'table',
            'noDataText': 'No notification templates have been added yet.',
            'sortable': ['notification_text'],
            'isServerPaginate': false
        },
        React.createElement(Thead, {}, React.createElement(Th, { 'column': 'notification_text' }, React.createElement('strong', {}, 'Notification Text')), React.createElement(Th, { 'column': 'scheduled_date' }, React.createElement('strong', {}, 'Scheduled Date')), React.createElement(Th, { 'column': 'sent_status' }, React.createElement('strong', {}, 'Sent Status')), React.createElement(Th, {
            'column': 'action',
            'style': {
                width: '120px',
                textAlign: 'center'
            }
        }, React.createElement('strong', {}, ' Action '))),
        _.map(this.props.notificationSchedules, repeatNotificationSchedule1.bind(this))
    ])), React.createElement(Button, {
        'tooltip': 'Schedule',
        'className': 'floating-add-button m-r-8',
        'style': { top: '90px' },
        'icon': 'add',
        'floating': true,
        'ripple': true,
        'mini': true,
        'onClick': () => {
            this.scheduleNotification();
        }
    }));
}